import React from 'react';
import { useTranslation } from 'react-i18next';
import RadioButton from '../../../common/RadioButton/RadioButton';
import { FormGroupProps } from './types';
import ReadOnlyField from '../../../common/ReadOnlyField/ReadOnlyField';

type ManufacturedByVmgFormGroupProps = FormGroupProps & {
  handleRadioButton: (field: string, e: any) => void;
};

export default function ManufacturedByVmgFormGroup({
  album,
  readonly,
  disabled,
  handleRadioButton,
}: ManufacturedByVmgFormGroupProps) {
  const { t } = useTranslation();
  const yesOption = t('product.yes');
  const noOption = t('product.no');

  return (
    <>
      {!readonly ? (
        <div className="form-group">
          <label
            htmlFor="isManufacturedByIngrooves"
            className="col-sm-3 form-label"
          >
            {' '}
            {t('product.editProduct.ingroovesManufacturingProduct')}
          </label>
          <div className="col-sm-3">
            <RadioButton
              options={[yesOption, noOption]}
              selectedOption={
                album.albumMetaData?.manufacturing?.isManufacturedByIngrooves
                  ? yesOption
                  : noOption
              }
              id="isManufacturedByIngrooves"
              name="isManufacturedByIngrooves"
              className="leftPadding"
              labelClass="leftPadding"
              onOptionChange={(e: any) => {
                handleRadioButton('isManufacturedByIngrooves', e);
              }}
              disabled={disabled}
            ></RadioButton>
          </div>
        </div>
      ) : (
        <ReadOnlyField
          id={'isManufacturedByIngrooves'}
          labelTitle={t('product.editProduct.ingroovesManufacturingProduct')}
          value={
            album.albumMetaData?.manufacturing?.isManufacturedByIngrooves
              ? yesOption
              : noOption
          }
        ></ReadOnlyField>
      )}
    </>
  );
}
